<template>
  <b-container>

    <b-row id="login-container">

      <b-col id="login" xl="6" offset-xl="3" md="8" offset-md="2"> 
        <div>
          <b-form class="form" @submit.prevent="validateBeforeSubmit" onsubmit="return false">  
            <h3 class="form-header bg-primary">Ellipse Configuration Tool</h3>

            <div class="form-content">
              
                
              <b-input-group class="pb-2">
                <b-input-group-prepend>
                  <div class="input-icon-prepend bg-primary">
                    <font-awesome-icon icon="user" transform="right-11 down-5"  :style="{ color: 'white' }" />
                  </div>
                </b-input-group-prepend>

                <b-form-input id="Username" type="text" @keyup.enter.native="submit" v-model="auth.email" required placeholder="Enter email" @change.native="success = null;"/>
              </b-input-group>

              
              <b-alert variant="success" :show="success">An email has been sent to the supplied address with further instructions.</b-alert>

              <b-row>
                <b-col md="6">
                  <b-button variant="primary" href="#" to="/login" block>
                    <!--Cancel-->
                    <font-awesome-icon icon="times" :style="{ color: 'white' }" />
                  </b-button>
                </b-col>

                <b-col md="6">

                  <b-button variant="primary" type="submit" block>
                    <!--Login-->
                    <font-awesome-icon icon="check" v-if="!pending" :style="{ color: 'white' }" />

                    <font-awesome-icon icon="spinner" spin :style="{ color: 'white' }" v-if="pending"></font-awesome-icon>
                  </b-button>
                </b-col>
              </b-row>
    
            </div>

          </b-form>
        </div>

        <p class="pt-5" id="footer_text" style="text-align: center;">
          <svg version="1.1" id="Layer_1" xmlns="&ns_svg;" xmlns:xlink="&ns_xlink;" width="21.56" height="14.02" viewBox="0 0 64.705 42.064" overflow="visible" enable-background="new 0 0 64.705 42.064" xml:space="preserve" style="padding-bottom: 2px">
            <g>
              <path d="M0,42.064L24.258,0l24.258,42.064H40.43L24.24,14.08L8.086,42.064H0z M16.172,42.064l10.793-18.686l4.043,7.014l-2.707,4.658h5.396l4.043,7.014H16.172z M33.68,11.707l6.75-11.672l24.275,42.029H51.223l-4.061-7.014h5.414L40.412,14.063l-2.672,4.658L33.68,11.707z"/>
            </g>
          </svg>
          <b>Logos Design A/S </b> | Nærum Hovedgade 6 | DK-2850 Nærum, Danmark | Tel +45 45 87 78 99
        </p>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import axios from 'axios'

export default {
  data() {
    return {
      success: undefined,
      pending: undefined,
      auth: {
        email: undefined,
      }
    };
  },

  computed: {},

  methods: {
    validateBeforeSubmit(evt) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submit();
        }
      });
    },
    submit(){
      console.log('Submit!');
      this.pending = true;
      axios.post("/api/v1/users/recoveryreferral", {
        Email: this.auth.email
      })
      .then( res => {
        this.success = true;
        this.pending = false;
      })
      .catch( err => {
        console.error('%j', err);
        this.pending = false;
      });
    }
  }

 
};
</script>

<style scoped>
  #login-container {
    margin: top 100px;
  }

  .form {
    margin-top: 100px;
    width: 100%;
    border-radius: 0 0 5px 5px;
    background-color: #E9E9E9;
    -webkit-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    -moz-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
  }

	#footer_text {
		font-size: 12px !important;
	}

  .form-content{
    padding: 20px 20px 20px 20px;
  }

  /* Override */
  h1 {
    margin: 0;
    font-size:30px;
    padding-top:20px;
  }
  @media (min-width: 992px) {
    h1 {
      font-size: 40px;
      padding-top:15px
    }
  }

  .form-header {
    font-weight: bold;
    font-family: 'Open Sans', sans-serif;
    text-transform: uppercase;
    color: white;
    text-align: center;
    background: #3388CC;
    border-radius: 5px 5px 0 0;
    -webkit-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    -moz-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    vertical-align: middle;
    height: 75px;
    padding-top: 20px;
  }

  .input-icon-prepend {
    background-color: #3388CC;
    border-radius: .25rem 0 0 .25rem;
    width: 40px;
    border: 1px solid #ced4da;
  }

  .input-icon-prepend > * svg {
    left: 50%;
  }

  .pm-blue-button {
    background-color: #3388CC;
    border: 1px solid #ced4da;
  }

</style>



// WEBPACK FOOTER //
// WebApp/components/RequestPasswordReset.vue